import { Text, Box, Center, Container } from "@chakra-ui/react";

const Header = (props) => {
  const { title } = props;

  return (
    <Box align="center" marginY="10">
      <Center>
        <Box marginBottom="2">
          <Container maxWidth="45rem">
            <Text
              as="b"
              lineHeight="1"
              align="center"
              fontSize={["2rem", "3rem", "3.75rem"]}
            >
              {title}
            </Text>
          </Container>
        </Box>
      </Center>
    </Box>
  );
};

export default Header;
